/* R44 menu – desktop mega menu, mobile drawer panels, brand filter and My Garage.
   Markup: snippets/r44-menu.liquid (desktop) and snippets/r44-menu-mobile.liquid (mobile drawer).
   My Garage (Shop by car panel, desktop + mobile): shows the visitor's saved car like the rest of the site
   (year, make, model) with "Search parts" (EasySearch results for exactly that car) and "Change vehicle"
   (pick another saved car, or choose a new one with Year / Make / Model). Vehicle data and search links come
   from EasySearch's own data (window.easysearch.tree). Logged-in / signed-up visitors have a new car saved to
   their garage when they search; everyone else just searches (saving goes through the pop-out email step). */
(function () {
  'use strict';
  var HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

  // My Garage styles live in assets/r44-menu-garage.css, next to this file
  (function () {
    var me = document.currentScript || document.querySelector('script[src*="r44-menu.js"]');
    if (!me || !me.src || document.querySelector('link[data-r44g-css]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = me.src.replace('r44-menu.js', 'r44-menu-garage.css'); l.setAttribute('data-r44g-css', '');
    document.head.appendChild(l);
  })();

  /* ---------------- Desktop ---------------- */
  function initDesktop(nav) {
    if (nav.__r44) return; nav.__r44 = true;
    var items = [].slice.call(nav.querySelectorAll('.r44nav__item'));
    var openItem = null, openTimer = 0, closeTimer = 0;

    function panelOf(item) { var b = item.querySelector('[data-r44nav-toggle]'); return b ? document.getElementById(b.getAttribute('aria-controls')) : null; }
    function close(item) {
      if (!item) return;
      var b = item.querySelector('[data-r44nav-toggle]'), p = panelOf(item);
      if (b) b.setAttribute('aria-expanded', 'false');
      if (p) p.hidden = true;
      if (openItem === item) openItem = null;
    }
    function open(item) {
      if (openItem === item) return;
      close(openItem);
      var b = item.querySelector('[data-r44nav-toggle]'), p = panelOf(item);
      if (!b || !p) return;
      b.setAttribute('aria-expanded', 'true');
      p.hidden = false;
      if (p.classList.contains('r44nav__panel--mega')) {
        p.style.maxHeight = Math.max(240, window.innerHeight - p.getBoundingClientRect().top - 12) + 'px';
      }
      openItem = item;
      if (item.dataset.kind === 'car' || item.dataset.kind === 'cat') Garage.apply();
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-r44nav-toggle]');
      if (!btn) {
        item.addEventListener('mouseenter', function () { if (HOVER.matches) { clearTimeout(openTimer); openTimer = setTimeout(function () { close(openItem); }, 120); } });
        return;
      }
      var isLink = btn.hasAttribute('data-r44nav-link');
      btn.addEventListener('click', function (e) {
        // Linked items (e.g. Shop by brand > Brands page): mouse click goes to the page; on touch the first tap opens the panel
        if (isLink && (HOVER.matches || openItem === item)) return;
        e.preventDefault();
        if (openItem === item) close(item); else open(item);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || (isLink && e.key === ' ')) {
          e.preventDefault(); open(item);
          var first = panelOf(item) && panelOf(item).querySelector('a, button, input');
          if (first) first.focus();
        }
      });
      item.addEventListener('mouseenter', function () {
        if (!HOVER.matches) return;
        clearTimeout(closeTimer); clearTimeout(openTimer);
        openTimer = setTimeout(function () { open(item); }, openItem ? 0 : 120);
      });
      item.addEventListener('mouseleave', function () {
        if (!HOVER.matches) return;
        // Keep the panel open while a Year / Make / Model list is in use (native dropdowns sit outside the panel)
        if (item.querySelector('[data-r44g].is-editing select:focus')) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { if (openItem === item) close(item); }, 220);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) { var b = openItem.querySelector('[data-r44nav-toggle]'); close(openItem); if (b) b.focus(); }
    });
    document.addEventListener('click', function (e) { if (openItem && !openItem.contains(e.target)) close(openItem); });
    nav.addEventListener('focusout', function (e) {
      if (openItem && e.relatedTarget && !openItem.contains(e.relatedTarget)) close(openItem);
    });
    window.addEventListener('pageshow', function () { close(openItem); });

    // Make tabs (hover or click switches the make)
    [].slice.call(nav.querySelectorAll('[role="tablist"]')).forEach(function (list) {
      var tabs = [].slice.call(list.querySelectorAll('[data-r44nav-tab]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab, p = document.getElementById(t.getAttribute('aria-controls'));
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (p) p.hidden = !on;
        });
        // Popular cars only show for their own make (BMW by default)
        var pop = list.closest('.r44nav__car') && list.closest('.r44nav__car').querySelector('[data-r44nav-popular]');
        if (pop) pop.hidden = pop.getAttribute('data-r44nav-popular') !== tab.getAttribute('data-make');
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('mouseenter', function () { if (HOVER.matches) select(t); });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowDown' ? 1 : e.key === 'ArrowUp' ? -1 : 0;
          if (n) { e.preventDefault(); select(tabs[(i + n + tabs.length) % tabs.length], true); }
        });
      });
    });

  }

  /* ---------------- Brand filter (desktop + mobile) ---------------- */
  var ACCENTS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g');
  var WORD_SPLIT = new RegExp('[ &+./-]+');
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(ACCENTS, '').replace(/[^a-z0-9]/g, ''); }
  function initDirectory(root) {
    if (root.__r44) return; root.__r44 = true;
    var input = root.querySelector('[data-r44nav-filter]');
    var list = root.querySelector('[data-r44nav-brands]'), empty = root.querySelector('[data-r44nav-empty]');
    var featured = root.querySelector('.r44bd__featured');
    var groups = [].slice.call(list.querySelectorAll('[data-letter]'));
    var letterBtns = [].slice.call(root.querySelectorAll('[data-r44bd-letter]'));
    var jump = root.getAttribute('data-mode') === 'jump';
    var links = [].slice.call(list.querySelectorAll('a[data-name]'));
    // Match from the start of the name or of any word in it ("tone" finds Deep Tone Industries, "h&r" finds H&R only)
    links.forEach(function (a) {
      var name = a.getAttribute('data-name') || '';
      a.__keys = [norm(name)].concat(name.split(WORD_SPLIT).map(norm).filter(Boolean));
    });
    function setLetter(l) { letterBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-r44bd-letter') === l); }); }
    function apply(q, letter) {
      var shown = 0;
      links.forEach(function (a) {
        var g = a.closest('[data-letter]').getAttribute('data-letter');
        var hit = (!q || a.__keys.some(function (k) { return k.indexOf(q) === 0; })) && (!letter || g === letter);
        a.parentNode.hidden = !hit; if (hit) shown++;
      });
      groups.forEach(function (g) { g.hidden = !g.querySelector('li:not([hidden])'); });
      if (empty) empty.hidden = shown > 0;
      if (featured) featured.hidden = !!(q || letter);
    }
    if (input) {
      input.addEventListener('input', function () { setLetter(''); apply(norm(input.value), ''); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { var first = list.querySelector('li:not([hidden]) a'); if (first) { e.preventDefault(); window.location.href = first.href; } }
      });
    }
    letterBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var l = b.getAttribute('data-r44bd-letter');
        if (jump) {
          if (input && input.value) { input.value = ''; apply('', ''); }
          var target = list.querySelector('[data-letter="' + l + '"]');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (input) input.value = '';
        setLetter(l); apply('', l);
      });
    });
  }

  /* ---------------- My Garage data: EasySearch vehicles + the visitor's saved cars ---------------- */
  var ES_GARAGE = 'easysearch-garage-items', DELIM = 'easysearch-preselect-delimiter';
  var PRIMARY_KEY = 'r44-garage-primary', DONE_KEY = 'r44-garage-signed-up';
  var GROUPS = ['M Models', '1 Series', '2 Series', '3 Series', '4 Series', '5 Series', '6 Series', '7 Series', '8 Series',
                'X Models', 'Z Models', 'i Models', 'Other Models'];
  var TOP_MAKE = 'BMW', OTHER_MAKES = ['Audi', 'Toyota'], OTHER_LABEL = 'Other Makes';
  var MODEL_FILTERS = { 'Toyota': /GR (Supra|Yaris)/i };

  function getLS(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function setLS(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function label(c) { return [c.year, c.make, c.model].join(' '); }
  function same(a, b) { return !!a && !!b && norm(label(a)) === norm(label(b)); }

  var ES = {
    tree: function () {
      var t = window.easysearch && window.easysearch.tree;
      return t && t[''] && t[''].length ? t : null;
    },
    ready: function (cb) {
      var n = 0, self = this;
      (function wait() {
        var t = self.tree();
        if (t || ++n > 60) return cb(t);
        setTimeout(wait, 250);
      })();
    },
    list: function (key) { var t = this.tree(); return (t && t[key]) || []; },
    years: function () { return this.list('').slice().sort(function (a, b) { return (+b) - (+a); }); },
    makes: function (y) { return this.list(y + ','); },
    models: function (y, m) { return this.list(y + ',' + m + ','); },
    url: function (c) {
      var u = this.list(c.year + ',' + c.make + ',' + c.model + ',')[0] || '';
      if (u && window.easysearch && typeof window.easysearch.addRootToUrl === 'function') {
        try { u = window.easysearch.addRootToUrl(u) || u; } catch (e) {}
      }
      return u;
    }
  };

  function savedCars() {
    try { if (window.R44Garage && typeof window.R44Garage.cars === 'function') return window.R44Garage.cars() || []; } catch (e) {}
    try {
      var raw = JSON.parse(getLS(ES_GARAGE) || 'null');
      var list = raw && raw.value ? raw.value : (Array.isArray(raw) ? raw : []);
      return list.map(function (s) {
        var p = String(s).split(DELIM);
        return { year: (p[0] || '').trim(), make: (p[1] || '').trim(), model: (p[2] || '').trim() };
      }).filter(function (c) { return c.year && c.make && c.model; });
    } catch (e) { return []; }
  }
  function primaryCar() {
    try { if (window.R44Garage && typeof window.R44Garage.primary === 'function') return window.R44Garage.primary(); } catch (e) {}
    var cars = savedCars(), chosen = getLS(PRIMARY_KEY);
    for (var i = 0; i < cars.length; i++) if (chosen && label(cars[i]) === chosen) return cars[i];
    return cars[cars.length - 1] || null;
  }
  function makePrimary(c) { setLS(PRIMARY_KEY, label(c)); }
  // Add a car to the EasySearch garage (same format the app uses) and make it the primary car
  function saveCar(c) {
    var raw = null;
    try { raw = JSON.parse(getLS(ES_GARAGE) || 'null'); } catch (e) {}
    var list = raw && raw.value ? raw.value.slice() : (Array.isArray(raw) ? raw.slice() : []);
    var item = c.year + DELIM + c.make + DELIM + c.model + DELIM;
    var exists = list.some(function (s) {
      var p = String(s).split(DELIM);
      return norm(p[0] + p[1] + p[2]) === norm(c.year + c.make + c.model);
    });
    if (!exists) list.push(item);
    var period = (window.easysearch && +window.easysearch.storageGaragePeriod) || 315360000;
    var expires = (raw && raw.expires) || String(Date.now() + period * 1000);
    setLS(ES_GARAGE, JSON.stringify({ value: list, expires: expires }));
    makePrimary(c);
  }

  // Known visitor (logged in, signed up on this browser, or identified by Klaviyo)?
  var klaviyoKnown = false;
  (function check(n) {
    var k = window.klaviyo;
    if (k && typeof k.isIdentified === 'function') {
      Promise.race([Promise.resolve(k.isIdentified()), new Promise(function (r) { setTimeout(function () { r(false); }, 4000); })])
        .then(function (v) { if (v === true) { klaviyoKnown = true; GarageUI.refreshAll(); } }, function () {});
    } else if (n < 40) { setTimeout(function () { check(n + 1); }, 250); }
  })(0);
  function testView() { try { return sessionStorage.getItem('r44-garage-test') || ''; } catch (e) { return ''; } }
  function knownVisitor() {
    var t = testView();
    if (t === '1') return false;
    if (t === '2') return true;
    var tag = document.querySelector('script[data-customer]');
    return (tag && tag.getAttribute('data-customer') === '1') || !!getLS(DONE_KEY) || klaviyoKnown;
  }

  /* ---------------- My Garage box in the menu ---------------- */
  var ARROW = '<svg viewBox="0 0 6 10" aria-hidden="true" focusable="false"><path d="M1 1l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
  var GarageUI = {
    // Swap the menu's old garage chips for the My Garage box (keeps the "My Garage" label)
    mount: function () {
      [].slice.call(document.querySelectorAll('[data-r44nav-garage]')).forEach(function (g) {
        if (g.querySelector('[data-r44g]')) return;
        [].slice.call(g.children).forEach(function (el) {
          if (!el.classList.contains('r44nav__label') && !el.classList.contains('r44m__label')) el.remove();
        });
        var box = document.createElement('div');
        box.className = 'r44g'; box.setAttribute('data-r44g', '');
        g.appendChild(box);
      });
    },
    boxes: function () { this.mount(); return [].slice.call(document.querySelectorAll('[data-r44g]')); },
    refreshAll: function () { var self = this; this.boxes().forEach(function (b) { if (!b.classList.contains('is-editing')) self.render(b); }); },

    render: function (box) {
      var car = primaryCar(), cars = savedCars();
      box.classList.remove('is-editing');
      var top = box.closest('.r44nav__car-top'); if (top) top.classList.remove('is-editing');
      if (!car) { this.edit(box, false); return; }
      var url = ES.url(car);
      box.innerHTML =
        '<div class="r44g__view">' +
          '<div class="r44g__car"><span class="r44g__dot" aria-hidden="true"></span><span class="r44g__car-text">' +
            '<span class="r44g__car-sub">' + esc(car.year + ' ' + car.make) + '</span>' +
            '<span class="r44g__car-name">' + esc(car.model) + '</span></span></div>' +
          '<a class="r44g__btn r44g__btn--go" data-r44g-go href="' + esc(url || '/pages/update-your-r44-garage') + '">Search parts ' + ARROW + '</a>' +
          '<button type="button" class="r44g__btn r44g__btn--line" data-r44g-change>Change vehicle</button>' +
        '</div>';
      if (!url) {
        // EasySearch data still loading: fill the link in when it arrives
        ES.ready(function () { var a = box.querySelector('[data-r44g-go]'); var u = ES.url(car); if (a && u) a.href = u; });
      }
      box.setAttribute('data-count', cars.length);
    },

    edit: function (box, canCancel) {
      var self = this, car = primaryCar(), cars = savedCars(), known = knownVisitor();
      box.classList.add('is-editing');
      var top = box.closest('.r44nav__car-top'); if (top) top.classList.add('is-editing');
      var others = cars.filter(function (c) { return !same(c, car); });
      var html = '';
      if (others.length) {
        html += '<div class="r44g__saved"><span class="r44g__mini">Your garage</span><ul class="r44g__chips" role="list">';
        others.forEach(function (c, i) {
          html += '<li><button type="button" class="r44g__chip" data-r44g-use="' + i + '"><span class="r44g__dot" aria-hidden="true"></span>' + esc(label(c)) + '</button></li>';
        });
        html += '</ul></div>';
      }
      html +=
        '<div class="r44g__pick">' +
          '<span class="r44g__mini">' + (others.length ? 'Or choose a new car' : (car ? 'Choose a different car' : 'Choose your car')) + '</span>' +
          '<div class="r44g__ymm">' +
            '<label class="r44g__sel"><span class="visually-hidden">Year</span><select data-r44g-year aria-label="Year"><option value="">Year</option></select></label>' +
            '<label class="r44g__sel"><span class="visually-hidden">Make</span><select data-r44g-make aria-label="Make" disabled><option value="">Make</option></select></label>' +
            '<label class="r44g__sel r44g__sel--model"><span class="visually-hidden">Model</span><select data-r44g-model aria-label="Model" disabled><option value="">Model</option></select></label>' +
            '<button type="button" class="r44g__btn r44g__btn--go" data-r44g-search disabled>' + (known ? 'Save &amp; search' : 'Search') + '</button>' +
          '</div>' +
          '<div class="r44g__foot">' +
            (canCancel ? '<button type="button" class="r44g__link" data-r44g-cancel>Cancel</button>' : '') +
            (!known ? '<span class="r44g__note">Want it saved for next time? <button type="button" class="r44g__link" data-r44nav-garage-add>Add it to My Garage</button></span>' : '') +
          '</div>' +
        '</div>';
      box.innerHTML = html;
      box.__others = others;

      var ySel = box.querySelector('[data-r44g-year]'), mSel = box.querySelector('[data-r44g-make]');
      var dSel = box.querySelector('[data-r44g-model]'), go = box.querySelector('[data-r44g-search]');
      function fill(sel, values, placeholder) {
        sel.textContent = '';
        var p = document.createElement('option'); p.value = ''; p.textContent = placeholder; sel.appendChild(p);
        values.forEach(function (v) {
          if (v && v.group) {
            var og = document.createElement('optgroup'); og.label = v.group;
            v.items.forEach(function (x) { var o = document.createElement('option'); o.value = x; o.textContent = x; og.appendChild(o); });
            sel.appendChild(og);
          } else { var o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o); }
        });
        sel.disabled = !values.length;
      }
      function update() { go.disabled = !(ySel.value && mSel.value && dSel.value); }
      ES.ready(function (tree) {
        if (!tree) { ySel.disabled = true; return; }
        fill(ySel, ES.years(), 'Year');
      });
      ySel.addEventListener('change', function () {
        fill(mSel, ySel.value ? self.sortMakes(ySel.value, ES.makes(ySel.value)) : [], 'Make');
        fill(dSel, [], 'Model');
        update();
      });
      mSel.addEventListener('change', function () {
        fill(dSel, mSel.value ? self.sortModels(mSel.value, ES.models(ySel.value, mSel.value)) : [], 'Model');
        update();
      });
      dSel.addEventListener('change', update);
    },

    // Same order as the site's other Year / Make / Model selectors (assets/r44-ymm-sort.js)
    sortMakes: function (year, makes) {
      var out = [], others = [];
      if (makes.indexOf(TOP_MAKE) > -1) out.push(TOP_MAKE);
      OTHER_MAKES.forEach(function (m) {
        if (makes.indexOf(m) === -1) return;
        var re = MODEL_FILTERS[m];
        if (re && !ES.models(year, m).some(function (x) { return re.test(x); })) return;
        others.push(m);
      });
      if (others.length) out.push({ group: OTHER_LABEL, items: others });
      return out;
    },
    sortModels: function (make, models) {
      var re = MODEL_FILTERS[make];
      if (re) return models.filter(function (x) { return re.test(x); });
      if (make !== TOP_MAKE) return models.slice();
      var classify = window.R44YmmSort && window.R44YmmSort.classify;
      if (!classify) return models.slice();
      var items = models.map(function (m, i) { return { m: m, i: i, k: classify(m) }; });
      items.sort(function (a, b) {
        if (a.k.group !== b.k.group) return a.k.group - b.k.group;
        if (a.k.sub !== b.k.sub) return a.k.sub < b.k.sub ? -1 : 1;
        if (a.k.gen !== b.k.gen) return a.k.gen - b.k.gen;
        if (a.k.num !== b.k.num) return a.k.num - b.k.num;
        return a.i - b.i;
      });
      var groups = [];
      items.forEach(function (it) {
        var last = groups[groups.length - 1];
        if (!last || last.g !== it.k.group) groups.push(last = { g: it.k.group, group: GROUPS[it.k.group] || 'Other Models', items: [] });
        last.items.push(it.m);
      });
      return groups;
    }
  };

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var box = t.closest('[data-r44g]');
    if (!box) return;
    if (t.closest('[data-r44g-change]')) {
      e.preventDefault(); e.stopImmediatePropagation();
      GarageUI.edit(box, true);
      var first = box.querySelector('[data-r44g-use]') || box.querySelector('[data-r44g-year]');
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (x) {} }, 30);
      return;
    }
    if (t.closest('[data-r44g-cancel]')) { e.preventDefault(); e.stopImmediatePropagation(); GarageUI.render(box); return; }
    var use = t.closest('[data-r44g-use]');
    if (use) {
      e.preventDefault(); e.stopImmediatePropagation();
      var c = (box.__others || [])[+use.getAttribute('data-r44g-use')];
      if (c) { makePrimary(c); GarageUI.refreshAll(); GarageUI.render(box); Garage.apply(); }
      return;
    }
    var go = t.closest('[data-r44g-search]');
    if (go && !go.disabled) {
      e.preventDefault();
      var car = {
        year: box.querySelector('[data-r44g-year]').value,
        make: box.querySelector('[data-r44g-make]').value,
        model: box.querySelector('[data-r44g-model]').value
      };
      var url = ES.url(car);
      if (!url) return;
      if (knownVisitor()) saveCar(car);
      window.location.href = url;
    }
  });

  /* ---------------- Vehicle pages: "Your car" link + category links for the saved car ---------------- */
  var Garage = {
    car: null, vehicle: null, loading: null, showAll: false,
    load: function () {
      if (this.loading) return this.loading;
      var nav = document.querySelector('[data-r44nav]');
      var url = (nav && nav.getAttribute('data-vehicles-url')) || '/collections/all?view=r44-vehicles';
      var KEY = 'r44-menu-vehicles-v1';
      try {
        var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (c && c.t > Date.now() - 6 * 3600 * 1000) { this.loading = Promise.resolve(c.v); return this.loading; }
      } catch (e) {}
      this.loading = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { vehicles: [] }; })
        .then(function (d) { var v = d.vehicles || []; try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {} return v; })
        .catch(function () { return []; });
      return this.loading;
    },
    match: function (list, car) {
      var mk = norm(car.make), md = norm(car.model);
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        if (norm(v.make) !== mk) continue;
        var ms = v.models || [];
        for (var j = 0; j < ms.length; j++) if (norm(ms[j]) === md) return v;
      }
      return null;
    },
    apply: function () {
      var self = this, car = primaryCar();
      GarageUI.refreshAll();
      this.renderMyCar(car);
      if (!car) { self.vehicle = null; self.render(null); return; }
      self.load().then(function (list) {
        self.car = norm(label(car)); self.vehicle = self.match(list, car);
        self.render(self.vehicle);
      });
    },
    // Mobile drawer "Your car" row: the saved car, linking to its EasySearch results
    renderMyCar: function (car) {
      [].slice.call(document.querySelectorAll('[data-r44nav-mycar]')).forEach(function (a) {
        a.hidden = !car;
        if (!car) return;
        var n = a.querySelector('[data-r44nav-mycar-name]'); if (n) n.textContent = label(car);
        var u = ES.url(car);
        if (u) a.href = u;
        else ES.ready(function () { var u2 = ES.url(car); a.href = u2 || '/pages/update-your-r44-garage'; });
      });
    },
    render: function (v) {
      var show = !!v && !this.showAll;
      [].slice.call(document.querySelectorAll('a[data-cat]')).forEach(function (a) {
        var u = show && v.cats && v.cats[a.getAttribute('data-cat')];
        a.href = u || a.getAttribute('data-href');
      });
      [].slice.call(document.querySelectorAll('[data-r44nav-catnote-default]')).forEach(function (el) { el.hidden = show; });
      [].slice.call(document.querySelectorAll('[data-r44nav-catnote-car]')).forEach(function (el) {
        el.hidden = !show;
        var n = el.querySelector('[data-r44nav-catcar]'); if (n && v) n.textContent = v.name;
      });
    }
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-r44nav-allcars]');
    if (b) { e.preventDefault(); Garage.showAll = true; Garage.render(Garage.vehicle); }
  });

  /* ---------------- Find your model (type-to-search) ---------------- */
  function initCarSearch(input) {
    if (input.__r44) return; input.__r44 = true;
    var scope = input.closest('.r44nav__car') || input.closest('.r44m__panel');
    var results = scope.querySelector('[data-r44nav-results]'), list = scope.querySelector('[data-r44nav-results-list]');
    var empty = scope.querySelector('[data-r44nav-results-empty]'), browse = scope.querySelector('[data-r44nav-browse]');
    var mobile = !!input.closest('.r44m');
    var links = [].slice.call(scope.querySelectorAll('a[data-search]')).map(function (a) {
      var words = a.textContent.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
      return { a: a, hay: norm(a.getAttribute('data-search')), words: words, make: a.getAttribute('data-make') || '' };
    });
    var arrow = '<svg class="' + (mobile ? 'r44m__arrow' : 'r44nav__arrow') + '" viewBox="0 0 6 10" aria-hidden="true"><path d="M1 1l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
    function run() {
      var words = input.value.trim().split(/ +/).map(norm).filter(Boolean);
      var on = words.length > 0;
      if (!mobile) scope.classList.toggle('is-searching', on); else if (browse) browse.hidden = on;
      results.hidden = !on;
      if (!on) return;
      list.innerHTML = '';
      var hits = links.filter(function (l) { return words.every(function (w) { return l.hay.indexOf(w) > -1; }); });
      // Exact word matches first ("m4" → M4s before M440i), then words starting with what was typed
      hits.forEach(function (l, i) {
        l.score = 0; l.i = i;
        words.forEach(function (w) {
          if (l.words.indexOf(w) > -1) l.score += 2;
          else if (l.words.some(function (x) { return x.indexOf(w) === 0; })) l.score += 1;
        });
      });
      hits.sort(function (a, b) { return b.score - a.score || a.i - b.i; });
      hits = hits.slice(0, 24);
      hits.forEach(function (l, i) {
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = l.a.getAttribute('href');
        if (!mobile) a.className = 'r44nav__result' + (i === 0 ? ' is-first' : '');
        var t = document.createElement('span'), sm = document.createElement('small');
        sm.textContent = l.make; t.appendChild(sm); t.appendChild(document.createTextNode(l.a.textContent));
        a.appendChild(t); a.insertAdjacentHTML('beforeend', arrow);
        li.appendChild(a); list.appendChild(li);
      });
      empty.hidden = hits.length > 0;
    }
    input.addEventListener('input', run);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { var f = list.querySelector('a'); if (f) { e.preventDefault(); window.location.href = f.href; } }
      if (e.key === 'Escape' && input.value) { e.stopPropagation(); input.value = ''; run(); }
    });
  }

  /* "Add it to My Garage" opens the EasySearch My Garage pop-out (with its email step for new visitors) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-r44nav-garage-add]');
    if (!b) return;
    e.preventDefault();
    var drawer = b.closest('.drawer');
    if (drawer) { var x = drawer.querySelector('[data-action="close"]'); if (x) x.click(); }
    var nav = document.querySelector('[data-r44nav]');
    if (nav) { var open = nav.querySelector('[data-r44nav-toggle][aria-expanded="true"]'); if (open) open.click(); }
    var es = document.querySelector('.easysearch-garage-btn-open');
    if (es) { setTimeout(function () { es.click(); }, drawer ? 350 : 0); }
    else { window.location.href = '/pages/update-your-r44-garage'; }
  });
  window.addEventListener('storage', function (e) { if (e.key === ES_GARAGE || e.key === PRIMARY_KEY) Garage.apply(); });

  /* ---------------- Mobile drawer panels ---------------- */
  function initMobile(root) {
    if (root.__r44) return; root.__r44 = true;
    var panels = {}, stack = ['root'];
    [].slice.call(root.querySelectorAll('[data-r44m-panel]')).forEach(function (p) { panels[p.getAttribute('data-r44m-panel')] = p; p.hidden = false; });
    function show(name) {
      var cur = panels[stack[stack.length - 1]], next = panels[name];
      if (!next || cur === next) return;
      cur.classList.remove('is-active'); cur.classList.add('is-behind'); cur.setAttribute('aria-hidden', 'true');
      next.classList.add('is-active'); next.removeAttribute('aria-hidden'); next.scrollTop = 0;
      stack.push(name);
      var b = next.querySelector('[data-r44m-back]'); if (b) setTimeout(function () { try { b.focus({ preventScroll: true }); } catch (e) {} }, 300);
      if (name === 'cat' || name === 'car') Garage.apply();
    }
    function back() {
      if (stack.length < 2) return;
      var cur = panels[stack.pop()], prev = panels[stack[stack.length - 1]];
      cur.classList.remove('is-active'); cur.setAttribute('aria-hidden', 'true');
      prev.classList.remove('is-behind'); prev.classList.add('is-active'); prev.removeAttribute('aria-hidden');
    }
    function reset() { while (stack.length > 1) back(); }
    Object.keys(panels).forEach(function (k) { if (k !== 'root') panels[k].setAttribute('aria-hidden', 'true'); });

    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-r44m-open]'); if (o) { show(o.getAttribute('data-r44m-open')); return; }
      if (e.target.closest('[data-r44m-back]')) { back(); return; }
      var acc = e.target.closest('[data-r44m-acc]');
      if (acc) {
        var t = document.getElementById(acc.getAttribute('aria-controls')), on = acc.getAttribute('aria-expanded') !== 'true';
        acc.setAttribute('aria-expanded', on ? 'true' : 'false'); if (t) t.hidden = !on;
      }
    });
    var drawer = root.closest('.drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () { if (drawer.hasAttribute('open')) Garage.apply(); else setTimeout(reset, 300); })
        .observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }
    Garage.apply();
  }

  /* ---------------- Collections: "All products" / "Fits your car" toggle ----------------
     Shown on collection pages (above the theme's results bar: product count + Sort by) ONLY when the visitor has a car
     in My Garage. "Fits your car" opens the same collection filtered to that car's EasySearch fitment tag
     (/collections/<handle>/<fitment tag>), keeping the current sort and filters; "All products" removes it.
     The car -> tag link comes from EasySearch's own data (window.easysearch.tree), so it matches the YMM search exactly.
     "Change vehicle" (right-hand end) opens the EasySearch My Garage pop-out; picking another car there makes it the
     primary car (snippets/r44-garage-primary.liquid), the toggle follows it, and if the page was showing the old car's
     parts it switches to the new car's.
     Counts come from templates/collection.r44-count.liquid. Styles: .r44fit in assets/r44-menu-garage.css. */
  var FitToggle = {
    cache: {},
    last: '',
    tagFor: function (car) {
      var u = ES.list(car.year + ',' + car.make + ',' + car.model + ',')[0] || '';
      var m = String(u).match(/\/collections\/all\/([^\/?#]+)\/?$/);
      return m ? decodeURIComponent(m[1]) : '';
    },
    where: function () {
      var m = location.pathname.match(/^((?:\/[a-z]{2}(?:-[a-z]{2,4})?)?\/collections\/([^\/]+))(?:\/([^\/]+))?\/?$/i);
      if (!m || m[2] === 'vendors' || m[2] === 'types') return null;
      return { base: m[1], tags: m[3] ? decodeURIComponent(m[3]).split('+').filter(Boolean) : [] };
    },
    isCarTag: function (t) { return /-esi\d+$/i.test(t); },
    // Links for both options; any other car's fitment tag in the address is dropped, other tags are kept
    urls: function (w, tag) {
      var self = this, q = this.query();
      var others = w.tags.filter(function (t) { return t !== tag && !self.isCarTag(t); });
      var enc = function (list) { return list.map(encodeURIComponent).join('+'); };
      return {
        on: w.tags.indexOf(tag) > -1,
        all: w.base + (others.length ? '/' + enc(others) : '') + q,
        fit: w.base + '/' + enc(others.concat(tag)) + q
      };
    },
    query: function () {
      var p = new URLSearchParams(location.search); p.delete('page');
      var s = p.toString(); return s ? '?' + s : '';
    },
    count: function (url) {
      if (!this.cache[url]) {
        this.cache[url] = fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=r44-count', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) { var n = parseInt(String(t).replace(/[^0-9]/g, ''), 10); return isNaN(n) ? null : n; })
          .catch(function () { return null; });
      }
      return this.cache[url];
    },
    render: function () {
      var bar = document.querySelector('.product-facet__meta-bar');
      var old = document.querySelector('[data-r44fit]');
      var w = this.where(), car = primaryCar();
      var tag = (bar && w && car) ? this.tagFor(car) : '';
      if (!tag) { if (old) old.remove(); return; }
      var u = this.urls(w, tag), on = u.on, allUrl = u.all, fitUrl = u.fit;
      var key = allUrl + '|' + fitUrl + '|' + on + '|' + label(car);
      if (old && old.__key === key && old.nextElementSibling === bar) return;
      if (old) old.remove();

      var name = String(car.model).replace(/\s*\([^)]*\)\s*$/, '');
      var el = document.createElement('div');
      el.className = 'r44fit'; el.setAttribute('data-r44fit', '');
      el.setAttribute('role', 'tablist'); el.setAttribute('aria-label', 'Filter by your car');
      el.innerHTML =
        '<a class="r44fit__tab" role="tab" data-r44fit-tab="all"><span>All products</span><span class="r44fit__count" data-r44fit-count></span></a>' +
        '<a class="r44fit__tab" role="tab" data-r44fit-tab="fit"><span class="r44fit__dot" aria-hidden="true"></span><span>Fits your <span class="r44fit__car">' + esc(name) + '</span><span class="r44fit__car-short">car</span></span><span class="r44fit__count" data-r44fit-count></span></a>' +
        '<button type="button" class="r44fit__change" data-r44nav-garage-add aria-label="Change vehicle">' +
          '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2 5h10M9 2l3 3-3 3M14 11H4M7 8l-3 3 3 3" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '<span>Change vehicle</span></button>' +
        // Phones: the car being filtered for + a Change link, on its own line under the two options
        '<div class="r44fit__mine"><span class="r44fit__dot" aria-hidden="true"></span><span class="r44fit__mine-car">' + esc(label(car)) + '</span>' +
          '<button type="button" class="r44fit__mine-change" data-r44nav-garage-add>Change</button></div>';
      var tabs = el.querySelectorAll('[data-r44fit-tab]');
      tabs[0].setAttribute('href', allUrl); tabs[0].setAttribute('aria-selected', on ? 'false' : 'true');
      tabs[1].setAttribute('href', fitUrl); tabs[1].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[1].title = 'Show only parts that fit your ' + label(car);
      el.__key = key;
      bar.parentNode.insertBefore(el, bar);

      [[tabs[0], allUrl], [tabs[1], fitUrl]].forEach(function (pair) {
        FitToggle.count(pair[1]).then(function (n) {
          if (n == null || !pair[0].isConnected) return;
          pair[0].querySelector('[data-r44fit-count]').textContent = '(' + n.toLocaleString() + ')';
          if (n === 0 && pair[0].getAttribute('aria-selected') !== 'true') pair[0].classList.add('is-empty');
        });
      });
    },
    start: function () {
      if (this.started || !/\/collections\//.test(location.pathname)) return;
      this.started = true;
      var self = this, t = 0;
      var run = function () { clearTimeout(t); t = setTimeout(function () { self.render(); }, 60); };
      ES.ready(run);
      // The theme reloads the results area when filters change: put the toggle back when that happens
      new MutationObserver(function () {
        var bar = document.querySelector('.product-facet__meta-bar'), el = document.querySelector('[data-r44fit]');
        if (bar && (!el || el.nextElementSibling !== bar)) run();
      }).observe(document.body, { childList: true, subtree: true });
      // A car added / changed in My Garage (menu, pop-out or another tab) updates the toggle
      setInterval(function () {
        var c = primaryCar(), k = c ? label(c) : '';
        if (k === self.last) return;
        var prev = self.last; self.last = k;
        // Car changed while viewing another car's parts: show the new car's parts instead
        var w = self.where(), tag = c ? self.tagFor(c) : '';
        if (prev && w && tag && w.tags.some(function (t) { return self.isCarTag(t) && t !== tag; })) {
          window.location.href = self.urls(w, tag).fit; return;
        }
        run();
      }, 1500);
      window.addEventListener('storage', run);
    }
  };

  function init() {
    [].slice.call(document.querySelectorAll('[data-r44nav]')).forEach(initDesktop);
    [].slice.call(document.querySelectorAll('[data-r44m]')).forEach(initMobile);
    [].slice.call(document.querySelectorAll('[data-r44bd]')).forEach(initDirectory);
    [].slice.call(document.querySelectorAll('[data-r44nav-carsearch]')).forEach(initCarSearch);
    setTimeout(function () { Garage.apply(); }, 400);
    FitToggle.start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
